import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, staffOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-brand-muted">
        <span data-testid="auth-checking">Checking session…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const isStaff = ["admin", "moderator", "super_admin"].includes(user.role);
  if (adminOnly && !isStaff) return <Navigate to="/dashboard" replace />;
  if (staffOnly && !isStaff) return <Navigate to="/dashboard" replace />;
  return children;
}
